import { useState, MouseEvent } from "react";
import { Button, Menu } from "@material-ui/core";
import BuildIcon from "@material-ui/icons/Build";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { useRootStyles } from "../../styles/useRootStyles";
import { PermissionNavItem } from "./PermissionNavItem";
import { resumeGeneratorAccessPermission } from "../../../../permissions";
import { compensationForgeAccessPermission } from "@internal/plugin-compensation-forge";
import { circlesAccessPermission } from "@internal/plugin-circles";
import DescriptionIcon from "@material-ui/icons/Description";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import AccountTreeIcon from "@material-ui/icons/AccountTree";

export const ToolsDropdown = () => {
  const classes = useRootStyles();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleMenuOpen = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        onClick={handleMenuOpen}
        className={classes.navButton}
        startIcon={<BuildIcon />}
        endIcon={<ArrowDropDownIcon />}
        color="inherit"
      >
        Tools
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <PermissionNavItem
          to="circles"
          icon={AccountTreeIcon}
          label="Circles"
          permission={circlesAccessPermission}
          onClick={handleMenuClose}
        />
        <PermissionNavItem
          to="resume-generator"
          icon={DescriptionIcon}
          label="Resumes"
          permission={resumeGeneratorAccessPermission}
          onClick={handleMenuClose}
        />
        <PermissionNavItem
          to="compensation-forge"
          icon={AttachMoneyIcon}
          label="Compensation Forge"
          permission={compensationForgeAccessPermission}
          onClick={handleMenuClose}
        />
      </Menu>
    </>
  );
};
